/**
 * @link https://span.studio
 * @copyright Copyright (c) Span Studio LLC
 * @license https://github.com/Span-Studio/sta100-craft5/blob/main/LICENSE.md
 * 
 * Entry Hero Image.
 * UI for uploading a hero image for an entry. 
 * 
 * @author John Pobojewski <https://john.pobojewski.com>
 */

import Modal from "/src/scripts/components/Modal.js";

class EntryHeroImage {
	init(url){
		console.log("EntryHeroImage: init()");

		document.querySelectorAll('.upload-assets').forEach(input => {
			const label = document.querySelector(`[for="${input.id}"]`);
			const labelVal = label.innerHTML;

			input.addEventListener('change', (e) => {
				let fileName = '';
				if (e.target.value) {
					fileName = e.target.value.split('\\').pop();
				}

				if (fileName) {
					this.readUrl(document.querySelector(".current-hero-image .preview img.current-image"), input, () => {
						document.querySelector(".current-hero-image .preview p").innerHTML = fileName;
						label.innerHTML = "Replace file";
					});
				}
			});

			input.addEventListener('focus', () => input.classList.add('has-focus'));
			input.addEventListener('blur', () => input.classList.remove('has-focus'));
		});
	}

	readUrl(id, input, callback){
		if (input.files && input.files[0] && id) {
			const file = input.files[0];
			const validTypes = ["image/gif", "image/jpeg", "image/png"];

			if (file.size < 5000000) {
				if (validTypes.includes(file.type)) {
					const reader = new FileReader();
					reader.onload = function(e) {
						id.src = e.target.result;
						id.srcset = "";
						callback();
					};
					reader.readAsDataURL(file);
				} else {
					Modal.build("<p>This file is not a GIF, JPG, or PNG image.</p>");
				}
			} else {
				Modal.build("<p>This file is bigger than 5 MB.</p>");
			}
		}
	}
}

export default new EntryHeroImage();
